import React from 'react';
import { useNavigate } from "react-router-dom";

interface ReadySectionProps {
    highlightColor: {
        primary: string;
        hover: string;
        gradient: {
            from: string;
            to: string;
            fromBlue: string;
            toPurple: string;
        };
    };
}

const ReadySection: React.FC<ReadySectionProps> = ({ highlightColor }) => {
    const navigate = useNavigate();

    return (
        <section id="about" className="py-20 pb-36 px-4 sm:px-6 lg:px-8 bg-black relative">
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white/10 to-transparent pointer-events-none"></div>
            <div className="max-w-7xl mx-auto relative z-10">
                <div className={`bg-neutral-900 rounded-xl p-12 text-center observe-fade opacity-0 border border-neutral-800`}>
                    <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                        Ready to See What Your Data Can Do?
                    </h3>
                    <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
                        CGM Sports brings all of your wearable and testing data into one clear, reliable system so you can understand trends, 
                        support better training decisions, and deliver a higher level of care and performance to the people you work with.
                    </p>
                    <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
                        Getting started is simple. Connect your existing devices, view accurate readiness and recovery 
                        signals, and use clean, organized information to guide daily planning and long-term progress. 
                        No extra work, no new workflows — just clarity you can trust.
                    </p>
                    <button 
                        onClick={() => navigate('/contact')}
                        className="px-8 py-4 text-lg text-white rounded-lg transition-colors font-medium"
                        style={{ backgroundColor: highlightColor.primary }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = highlightColor.hover;
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = highlightColor.primary;
                        }}
                    >
                        CONTACT US TODAY
                    </button>
                </div>
            </div>
        </section>
    );
};

export default ReadySection;